var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallRecorderIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "270px",
    viewBox: "0 0 360 270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-vngzxsxmhz-1",
    x: 0,
    y: 0,
    width: 360,
    height: 270
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.179766802%",
    y1: "49.8%",
    x2: "99.8000404%",
    y2: "49.8%",
    id: "linearGradient-vngzxsxmhz-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FF",
    offset: "26.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7DEFF",
    offset: "68.89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7C8FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.208333333%",
    y1: "50.4166667%",
    x2: "99.7916667%",
    y2: "50.4166667%",
    id: "linearGradient-vngzxsxmhz-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F6FF",
    offset: "26.24%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7DEFF",
    offset: "68.89%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7C8FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing_03",
    transform: "translate(-290.000000, -3330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portfolio_01",
    transform: "translate(-150.000000, 3000.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 10,
    transform: "translate(440.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-vngzxsxmhz-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-vngzxsxmhz-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#DCDCDE",
    xlinkHref: "#path-vngzxsxmhz-1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EBEBED",
    cx: 620,
    cy: 465,
    r: 70
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(595.000000, 440.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,50 L12,50 C5.4,50 0,44.6 0,38 L0,12 C0,5.4 5.4,0 12,0 L38,0 C44.6,0 50,5.4 50,12 L50,38 C50,44.6 44.6,50 38,50 Z",
    id: "Path",
    fill: "#5313AD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15.5 L14.9,15.5 L17.8,22.9 L14.1,25.1 C15.7,28.3 18.3,30.9 21.5,32.5 L23.7,28.8 L31.1,31.7 L31.1,37.6 C31.1,39.2 29.8,40.5 28.2,40.5 C16.3,39.8 6.9,30.3 6.1,18.4 C6,16.8 7.4,15.5 9,15.5",
    id: "Path",
    fill: "url(#linearGradient-vngzxsxmhz-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,9.5 L38,9.5 C41.3,9.5 44,12.2 44,15.5 L44,15.5 C44,18.8 41.3,21.5 38,21.5 L26,21.5 C22.7,21.5 20,18.8 20,15.5 L20,15.5 C20,12.2 22.6,9.5 26,9.5 Z",
    id: "Path",
    fill: "url(#linearGradient-vngzxsxmhz-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5416B0",
    fillRule: "nonzero",
    cx: 26,
    cy: 15.5,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1,17.4 L31.1,15.9 L31.1,15.9 L32.1,17.4 L33.2,17.4 L32.1,15.8 C32.6,15.6 32.9,15.3 32.9,14.7 C32.9,13.9 32.1,13.5 31.5,13.5 L30.3,13.5 L30.3,17.3 L31.1,17.3 L31.1,17.4 Z M31.4,14.3 C31.7,14.3 31.9,14.5 31.9,14.7 C31.9,15 31.7,15.1 31.3,15.1 L31.1,15.1 L31.1,14.2 L31.4,14.2 L31.4,14.3 Z M36.2,16.6 L34.6,16.6 L34.6,15.7 L36.2,15.7 L36.2,15 L34.6,15 L34.6,14.2 L36.2,14.2 L36.2,13.5 L33.7,13.5 L33.7,17.3 L36.2,17.3 L36.2,16.6 Z M39.9,13.9 C39.5,13.6 39.1,13.5 38.7,13.5 C38.1,13.5 37.7,13.7 37.3,14.1 C36.9,14.5 36.7,14.9 36.7,15.5 C36.7,16.1 36.9,16.5 37.3,16.9 C37.7,17.3 38.1,17.5 38.7,17.5 C39.2,17.5 39.6,17.3 40,17 L39.5,16.4 C39.3,16.6 39,16.7 38.7,16.7 C38,16.7 37.6,16.2 37.6,15.5 C37.6,15.2 37.7,14.9 37.9,14.7 C38.1,14.5 38.4,14.3 38.7,14.3 C39,14.3 39.2,14.4 39.5,14.6 L39.9,13.9 Z",
    id: "Shape",
    fill: "#5416B0",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallRecorderIco);
export default __webpack_public_path__ + "static/media/callRecorderIco.5e2b190f37c50e58fc3bb59549ff3733.svg";
export { ForwardRef as ReactComponent };